import{useEffect as t,useState as n}from"react";function i(){let[e,r]=n(!0);return t(()=>{r(!1)},[]),{isServerSideRendering:e}}export{i as a};
